export const html = `
<div>
<p><h2>TERMOS E CONDIÇÕES DE USO – GENERICO</h2></p>
<p>Este documento eh generico!</p>
</div>
`;
